module.exports = __webpack_public_path__ + "fonts/3768D4_0_0.a8fb0ad.woff";